module.exports = __webpack_public_path__ + "static/t_323_719-45a84d4f0955fea14e6c227200c0ede1.png";